import { FC, useEffect } from "react";
import Logo from "shared/Logo/Logo";
import Navigation from "shared/Navigation/Navigation";
import SearchDropdown from "./DropDowns/SearchDropdown";
import ButtonPrimary from "shared/Button/ButtonPrimary";
// import MenuBar from "shared/MenuBar/MenuBar";
// import SwitchDarkMode from "shared/SwitchDarkMode/SwitchDarkMode";
import HeroSearchForm2MobileFactory from "components/HeroSearchForm2Mobile/HeroSearchForm2MobileFactory";
import AvatarDropdown from "./DropDowns/AvatarDropdown";
import { useDispatch, useSelector } from "react-redux";
import { Client } from "data/types/user";
import { useGetMeClientQuery } from "application/features/client/clientApiSlice";
import { selectCurrentLoggedClient, setLoggedClient } from "application/features/clientAuth/authClientSlice";
import { useLocation } from "react-router-dom";
import MyTrip from "./MyTrip";
// import ChangeLanguage from "components/ChangeLanguage/ChangeLanguage";
import { useTranslation } from "react-i18next";

export interface ClientNavProps {
  className?: string;
}

const ClientNav: FC<ClientNavProps> = ({ className = "" }) => {

  const { t, ready } = useTranslation("translation");
  const { data, isLoading } = useGetMeClientQuery({})
  const client: Client = useSelector(selectCurrentLoggedClient);

  const dispatch = useDispatch()
  useEffect(() => {
    if (!isLoading && data) {
      dispatch(setLoggedClient({ client: data }))
    }
  }, [isLoading])

  const location = useLocation();

  if (!ready) return null;

  if (!location.pathname.endsWith("booking/calendar") && !location.pathname.endsWith("booking/summary") && !location.pathname.endsWith("booking/payment")) {
    return (
      <div className={`nc-ClientNav relative z-10 ${className}`}>
        <div className="px-4 lg:container py-4 lg:py-5 relative flex justify-between items-center">
          <div className="hidden md:flex justify-start flex-1 items-center space-x-4 sm:space-x-10">
            <Logo />
            <Navigation />
          </div>

          <div className="lg:hidden flex-[3] max-w-lg !mx-auto md:px-3">
            <HeroSearchForm2MobileFactory />
          </div>

          <div className="hidden md:flex flex-shrink-0 items-center justify-end flex-1 lg:flex-none text-neutral-700 dark:text-neutral-100">
            <div className="hidden xl:flex items-center space-x-0.5">

              <SearchDropdown />
              <div className="px-1" />
              <MyTrip /> 
              <div className="px-1" />
              {
                client ?
                  <AvatarDropdown isClient url={client.client_uuid ? client.avatar ? client.avatar : "https://www.hotelnicolaas.nl/images/joomlart/demo/default.jpg" : "https://www.hotelnicolaas.nl/images/joomlart/demo/default.jpg"} />
                  :
                  <ButtonPrimary href="/login">{t("translation:navbar.loginButtonText")}</ButtonPrimary>
              }
              <div className="px-1" />
              {/* <ChangeLanguage /> */}
            </div>
            <div className="flex items-center">
              {/* <SwitchDarkMode /> */}
              {/* <div className="px-1" /> */}
              {/* <MenuBar menuNavItems={[]} /> */}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="p-5">
        <Logo />
      </div>
    )
  }
};

export default ClientNav;
